import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';

/**
 * React Query hook for the recruiter list.
 *
 * @param {Object} [options] - Hook options
 * @param {boolean} [options.enabled=true] - Whether the query should execute
 * @param {boolean} [options.refetchOnWindowFocus=false] - Refetch on window focus
 */
export const useGetRecruiters = (options) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_RECRUITERS'],
    queryFn: () => UsersService.getRecruiters(),
    enabled: options?.enabled ?? true,
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    // Reference data — staff join and leave on the order of weeks, so without
    // this every navigation back to a list refetches the whole role. Matches
    // useProfileInfo and useGetPromotions; the test render sets staleTime 0, so
    // suites still see each query fire.
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
